import React, { useEffect } from 'react';
import axios from 'axios';

const ImageLoader = ({ searchQuery, page, imagesPerPage, onImagesLoaded }) => {
  useEffect(() => {
    const fetchData = async () => {
      if (searchQuery) {
        try {
          const response = await axios.get('https://api.unsplash.com/search/photos', {
            params: {
              query: searchQuery,
              page: page,
              per_page: imagesPerPage,
              client_id: 'KaLo4SgZ3koeY9ENsuGmIbQlGKNGOVgmINaKj6hzsHQ',
            },
          });
          onImagesLoaded(response.data.results, response.data.total_pages);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      } else {
        try {
          const response = await axios.get('https://api.unsplash.com/photos', {
            params: {
              page: page,
              per_page: imagesPerPage,
              client_id: 'KaLo4SgZ3koeY9ENsuGmIbQlGKNGOVgmINaKj6hzsHQ',
            },
          });
          onImagesLoaded(response.data, 0);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
    };

    // Call fetchData when necessary
    fetchData();
  }, [page, searchQuery, imagesPerPage, onImagesLoaded]);

  return null;
};

export default ImageLoader;
